import React from "react";
import { Doughnut } from "react-chartjs-2";

import { ArcElement, Chart, ChartData, ChartOptions, Legend, Tooltip } from "chart.js";

import { Icon } from "components";

Chart.register(ArcElement, Legend, Tooltip);

type PayoutSummaryDonutChartProps = {
  progressPct: number;
};

export function PayoutSummaryDonutChart({ progressPct }: PayoutSummaryDonutChartProps) {
  const clampedProgress = Math.max(0, Math.min(progressPct, 100));
  const data: ChartData<"doughnut"> = {
    datasets: [
      {
        data: [clampedProgress, 100 - clampedProgress],
        backgroundColor: ["#ecf86e", "#e8e8e8"],
        borderWidth: 0,
        hoverOffset: 0,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutout: "68%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <div className="pcd-donut" data-testid="payout-summary-donut">
      <Doughnut className="pcd-donut-canvas" data={data} options={options} />
      <Icon iconName="klim/money-plant" size="m-light" className="pcd-donut-icon" />
    </div>
  );
}
